import cypressIds from 'Components/cypress_ids.json';
import { SimilarVehiclesCard } from 'Components/SimilarVehiclesComponents/SimilarVehicles/SimilarVehiclesCard/SimilarVehiclesCard';
import {
	triggerRecommendedVehicleCardClickedEvent,
	triggerRecommendedVehicleCardIsShortlistedEvent,
} from 'Services/analytics/events';
import { applyCypressData } from 'Utilities/helpers';

import { useSimilarVehiclesContext } from '../SimilarVehiclesProvider/SimilarVehiclesProvider';

import styles from './SimilarVehiclesVehiclesGrid.module.scss';

export const SimilarVehiclesVehiclesGrid: React.FC = () => {
	const { similarVehicles } = useSimilarVehiclesContext();

	return (
		<section className={styles.grid} {...applyCypressData(cypressIds.containers.similarVehiclesGrid)}>
			{similarVehicles.map((vehicle) => (
				<div key={vehicle.id} className={styles.item}>
					<SimilarVehiclesCard
						onShortlisted={(id, url) => triggerRecommendedVehicleCardIsShortlistedEvent({ id, url })}
						onVehicleCardClick={(id, url) => triggerRecommendedVehicleCardClickedEvent({ id, url })}
						vehicle={vehicle}
					/>
				</div>
			))}
		</section>
	);
};
